/** Thrace programme countries — nation IDs match thrace.epiunits / inventory. */

export type ThraceNation = {
  nationId: number;
  label: string;
  /** Freedom/EDSSe region code */
  region: 'GR' | 'BG' | 'TK';
  templateId: string;
  fileName: string;
  aliases: string[];
};

export const THRACE_NATIONS: ThraceNation[] = [
  {
    nationId: 300,
    label: 'Greece',
    region: 'GR',
    templateId: 'greece',
    fileName: 'ThraceActivitiesGreece',
    aliases: ['greece', 'grc', 'gr', 'hellenic republic', 'ελλάδα'],
  },
  {
    nationId: 100,
    label: 'Bulgaria',
    region: 'BG',
    templateId: 'bulgaria',
    fileName: 'ThraceActivitiesBulgaria',
    aliases: ['bulgaria', 'bgr', 'bg', 'българия'],
  },
  {
    nationId: 792,
    label: 'Türkiye',
    region: 'TK',
    templateId: 'turkey',
    fileName: 'ThraceActivitiesTurkey',
    aliases: ['türkiye', 'turkiye', 'turkey', 'tur', 'tk', 'tr', 'republic of turkey'],
  },
];

function normalizeCountry(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/** Map user profile country string → Thrace nation, or null if unknown. */
export function resolveThraceNation(country?: string | null): ThraceNation | null {
  if (!country) return null;
  const n = normalizeCountry(country);
  return (
    THRACE_NATIONS.find(
      (t) =>
        normalizeCountry(t.label) === n ||
        t.aliases.some((a) => normalizeCountry(a) === n),
    ) || null
  );
}

export function isThraceAdmin(role?: string | null): boolean {
  return (role || '').toLowerCase() === 'admin';
}

/** Nations the current user may select. Admins see all; others their country only. */
export function thraceNationsForUser(
  role?: string | null,
  country?: string | null,
): ThraceNation[] {
  if (isThraceAdmin(role)) return THRACE_NATIONS;
  const mine = resolveThraceNation(country);
  return mine ? [mine] : THRACE_NATIONS;
}

/** Shared select classes — room for the Tailwind Forms chevron (do not use appearance-auto:
 *  that restores the native arrow and doubles up with the plugin chevron). */
export const THRACE_SELECT_CLASS =
  'w-full min-w-[10rem] pl-3 pr-10 py-2 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-green-500';
